"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("./..");

var _polished = require("polished");

var ValueItem = function ValueItem(_ref) {
  var icon = _ref.icon,
      heading = _ref.heading,
      children = _ref.children,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? 'column' : _ref$layout,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? '280px' : _ref$maxWidth;
  var src = icon.src,
      alt = icon.alt;
  var stacked = layout === 'column';
  return /*#__PURE__*/_react["default"].createElement(_.Flex, {
    "data-testid": "valueItem",
    flexDirection: layout,
    alignItems: stacked ? 'center' : 'start',
    maxWidth: maxWidth
  }, /*#__PURE__*/_react["default"].createElement(_.Image, {
    src: src,
    alt: alt,
    size: (0, _polished.rem)('44px')
  }), /*#__PURE__*/_react["default"].createElement(_.Flex, {
    flexDirection: "column",
    pl: stacked ? 0 : 4
  }, /*#__PURE__*/_react["default"].createElement(_.Heading.h4, {
    fontSize: (0, _polished.rem)(stacked ? '20px' : '18px'),
    pt: stacked ? 4 : 0,
    textAlign: stacked ? 'center' : 'left'
  }, heading), children && /*#__PURE__*/_react["default"].createElement(_.Text, {
    textAlign: stacked ? 'center' : 'left',
    color: "greys.steel",
    fontSize: stacked ? 'lg' : 'md'
  }, children)));
};

ValueItem.propTypes = {
  icon: _propTypes["default"].shape({
    src: _propTypes["default"].string.isRequired,
    alt: _propTypes["default"].string.isRequired
  }).isRequired,
  heading: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  layout: _propTypes["default"].oneOf(['row', 'column']),
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].array])
};
var _default = ValueItem;
exports["default"] = _default;